import Vue from "vue";

export function afterEach(to) {
	Vue.nextTick(() => {
		document.title = to.meta.title ? `${to.meta.title} | Voip Business` : 'Universal Portal | Voip Business';
	});
}